var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInprogressIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.653,
    height: 18.288,
    viewBox: "0 0 17.653 18.288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-in-progress-5942531",
    transform: "translate(-0.406 -348.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8766",
    "data-name": "Group 8766",
    transform: "translate(0.406 348.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9673",
    "data-name": "Path 9673",
    d: "M529.629,366.442a.187.187,0,0,0,.131-.053,8.364,8.364,0,0,1,4.594-2.285.188.188,0,0,0-.056-.371,8.738,8.738,0,0,0-4.8,2.387.188.188,0,0,0,.131.322Z",
    transform: "translate(-526.808 -362.963)",
    fill: "#35ab99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9674",
    "data-name": "Path 9674",
    d: "M329.815,612.176a8.337,8.337,0,0,1,1.814-5.228.188.188,0,1,0-.294-.233,8.709,8.709,0,0,0-1.9,5.461.188.188,0,0,0,.375,0Z",
    transform: "translate(-329.44 -602.677)",
    fill: "#35ab99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9675",
    "data-name": "Path 9675",
    d: "M339.488,1117.078a.188.188,0,0,0,.134-.319,8.346,8.346,0,0,1-2.3-4.606.188.188,0,0,0-.371.056,8.716,8.716,0,0,0,2.4,4.813A.187.187,0,0,0,339.488,1117.078Z",
    transform: "translate(-336.854 -1101.376)",
    fill: "#35ab99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9676",
    "data-name": "Path 9676",
    d: "M584.7,1529.737a8.37,8.37,0,0,1-4.457-1.779.188.188,0,0,0-.233.294,8.747,8.747,0,0,0,4.656,1.859h.017a.188.188,0,0,0,.017-.375Z",
    transform: "translate(-576.638 -1511.824)",
    fill: "#35ab99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9677",
    "data-name": "Path 9677",
    d: "M1006.831,309.075a8.814,8.814,0,0,0-4.828-2.847l.091-.868-1.924.857,1.7,1.238.089-.851a8.456,8.456,0,0,1,6.656,8.255,8.211,8.211,0,0,1-.043.844,8.447,8.447,0,0,1-7.556,7.563.188.188,0,0,0,.018.374h.019a8.824,8.824,0,0,0,7.892-7.9,8.587,8.587,0,0,0,.045-.882A8.819,8.819,0,0,0,1006.831,309.075Z",
    transform: "translate(-991.341 -305.36)",
    fill: "#35ab99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9678",
    "data-name": "Path 9678",
    d: "M654.735,676.838a4.668,4.668,0,1,0-4.668,4.668A4.673,4.673,0,0,0,654.735,676.838Zm-3.046-.963-1.849,2.414a.188.188,0,0,1-.149.073h-.011a.187.187,0,0,1-.15-.091l-.7-1.184a.188.188,0,0,1,.323-.192l.562.946,1.681-2.194a.188.188,0,1,1,.3.229Z",
    transform: "translate(-641.241 -667.342)",
    fill: "#35ab99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogressIcon);
export default __webpack_public_path__ + "static/media/inprogress-icon.f9797dbb7e6e18cd905b60f5cfc5c9a8.svg";
export { ForwardRef as ReactComponent };